module.exports = __webpack_public_path__ + "img/salsa_1909.d0d44dc4.jpg";